<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      :style="'background: linear-gradient(141deg,rgba(43, 11, 73, 1) 0%, rgba(43, 11, 73, 1) 59%, rgba(255, 49, 205, 1) 100%);'"
      app
      width="300"
    >
      <!-- Top Menu -->
      <v-list :dark="true">
        <v-list-item class="px-6 pr-8 pt-2">
          <v-list-item-content class="text-center">
            <v-img :src="logo" contain :class="'px-8'"></v-img>
            <v-list-item-subtitle>Alpha Version 0.1.1</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-sheet color="transparent" height="128" width="100%"></v-sheet>

      <!-- Second Menu -->
      <v-list :dark="true" dense nav>
        <v-list-item
          v-for="item in items"
          :key="item.text"
          link
          :to="item.link"
          color="#ffffff"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <template v-slot:append>
        <v-divider :style="'border-color: rgba(255,255,255,0.25)'"></v-divider>
        <v-list :dark="true" dense nav>
          <v-list-item
            v-for="item in logoutItems"
            :key="item.text"
            link
            @click="logout"
            color="#ffffff"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
// Vercel Speed Insights
import { webVitals } from './vitals.js'
import logo from '@/assets/frameplay-logo-2026-white.png'
import blob from '@/assets/blob.png'

export default {
  name: 'App',
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'Frameplay Mockup Generator',
    // all titles will be injected into this template
    titleTemplate: `%s | Frameplay Mockup Generator`,
  },
  data: () => ({
    logo,
    blob,
    drawer: true,
    items: [
      {
        icon: 'mdi-image-area',
        text: 'In-Game Screenshots',
        link: { name: 'ScenesV1' },
      },
    ],
    logoutItems: [
      {
        icon: 'mdi-logout',
        text: 'Log Out',
      },
    ],
  }),
  mounted() {
    let analyticsId = process.env.VUE_APP_VERCEL_ANALYTICS_ID

    if (analyticsId) {
      webVitals({
        path: this.$route.path,
        params: this.$route.params,
        analyticsId,
        debug: true,
      })
    }
  },
  computed: {
    profilePic() {
      return this.$auth.user.picture
    },
  },
  methods: {
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      })
    },
  },
}
</script>
